__turbopack_context__.v({
  "addBtn": "sKSjtG_addBtn",
  "addBtnLabel": "sKSjtG_addBtnLabel",
  "empty": "sKSjtG_empty",
  "projects": "sKSjtG_projects",
  "seeAllBtn": "sKSjtG_seeAllBtn",
  "seeAllBtnLabel": "sKSjtG_seeAllBtnLabel",
  "showAll": "sKSjtG_showAll",
});
